import type { ReferencePrompt } from '@/app/types';

export const countAudioReferenceItems = (referencePrompts?: ReferencePrompt[]) => {
  if (!Array.isArray(referencePrompts)) return 0;

  let count = 0;
  for (const reference of referencePrompts) {
    if (reference.type === 'image' || reference.type === 'video') {
      count += 1;
    } else if (reference.type === 'element' && reference.prompt?.voice?.id) {
      count += 1;
    }

    if (count > 2) return count;
  }

  return count;
};

export const isAudioAndVoiceDisabled = (referencePrompts?: ReferencePrompt[]) =>
  countAudioReferenceItems(referencePrompts) > 2;
